<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-people"></i> {{rolesList.rolesList_0}}
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
		  <el-form :model="query" ref="query">
			<div class="handle-box">
				<el-row>
					<el-col :span="20">
						<div class="grid-content bg-purple">
							<el-input v-model="query.bafname" clearable :placeholder="rolesList.rolesList_1" class="handle-input mr10"></el-input>
						</div>
					</el-col>
					<el-col :span="4">
						<div class="grid-content bg-purple-light">
							<el-button :disabled="!hasPerms(buttonPerms.searchPerms)" type="warning" icon="el-icon-search" @click="handleSearch">{{rolesList.rolesList_4}}</el-button>
							<el-button :disabled="!hasPerms(buttonPerms.addPerms)" type="primary" icon="el-icon-plus" @click="handleAdd">{{rolesList.rolesList_5}}</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
			<el-table :data="tableData" border class="table" highlight-current-row @selection-change="selectionChange"
          @current-change="handleRoleSelectChange" v-loading="loading"
			 :default-sort = "{prop: 'BAFMSID', order: 'ascending'}" header-cell-class-name="table-header" :row-key="getRowKeys">
				<el-table-column prop="BAFMSID" label="ID" :formatter="idFormat" width="100" align="center" sortable></el-table-column>
				<el-table-column prop="BAFNAME" :label="rolesList.rolesList_6" align="center" width="200"></el-table-column>
				<el-table-column prop="BAFREMK" :label="rolesList.rolesList_7" align="center"></el-table-column>
				<el-table-column prop="UAAEMAL" :label="rolesList.rolesList_8" align="center" width="200"></el-table-column>
				<el-table-column prop="BAFINDT" :label="rolesList.rolesList_9" align="center" :formatter="dateFormat" sortable width="200"></el-table-column>
				<el-table-column :label="rolesList.rolesList_10" width="180" align="center">
					<template slot-scope="scope">
						<el-button :disabled="!hasPerms(buttonPerms.editPerms)" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">{{rolesList.rolesList_11}}</el-button>
						<el-button :disabled="!hasPerms(buttonPerms.deletePerms)" type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index,scope.row)">{{rolesList.rolesList_12}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next, jumper" :current-page="this.query.pageIndex" :page-size="this.query.pageSize"
				 :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
			</div>
		  </el-form>
		  <!--新增编辑界面-->
		  <div v-if="dialogVisible">
			<el-dialog :title="operation?rolesList.rolesList_13:rolesList.rolesList_14" :visible.sync="dialogVisible" width="30%">
		      <el-form ref="dataForm" :model="dataForm" :rules="dataFormRules" label-width="150px">
		         <el-row>
		  			<el-col :span="19">
						<el-form-item label="ID" prop="BAFMSID" v-if="false">
		  					<el-input v-model="dataForm.BAFMSID" :disabled="true" auto-complete="off"></el-input>
		  				</el-form-item>
		  			 </el-col>
		  			 <el-col :span="5"></el-col>
		  		</el-row>
		  		<el-row>
		  			<el-col :span="19">
		  				<el-form-item :label="rolesList.rolesList_36" prop="BAFNAME">
		  					<el-input v-model="dataForm.BAFNAME" auto-complete="off" maxlength="50"></el-input>
		  				</el-form-item>
		  			</el-col>
		  			<el-col :span="5"></el-col>
		  		</el-row>
				<el-row>
					<el-col :span="19">
						<el-form-item :label="rolesList.rolesList_37" prop="BAFREMK">
							<el-input v-model="dataForm.BAFREMK" auto-complete="off" type="textarea" maxlength="50"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5"></el-col>
				</el-row>
		      </el-form>
		      <span slot="footer" class="dialog-footer">
		          <el-button @click="dialogVisible = false">{{rolesList.rolesList_15}}</el-button>
		  		<el-button type="primary" @click="submitForm" :loading="editLoading">{{rolesList.rolesList_16}}</el-button>
		      </span>
		  </el-dialog>
		  </div>
		  <!--角色菜单，表格树内容栏-->
		  <div class="menu-container" :v-if="true">
		  	<div class="menu-header">
		  		<span><B>{{rolesList.rolesList_35}}</B></span>
		  	</div>
			<el-tree :data="menuData" size="mini" show-checkbox node-key="id" :props="defaultProps"
				style="width: 100%;pading-top:20px;" ref="menuTree" :render-content="renderContent"
				v-loading="menuLoading" :element-loading-text="rolesList.rolesList_17" :check-strictly="true"
				@check-change="handleMenuCheckChange">
			</el-tree>
		  	<div style="float:left;padding-left:24px;padding-top:12px;padding-bottom:4px;">
		  		<el-checkbox v-model="checkAll" @change="handleCheckAll" :disabled="this.selectRole.BAFMSID == null"><b>{{rolesList.rolesList_18}}</b></el-checkbox>
		  	</div>
		  	<div style="float:right;padding-right:15px;padding-top:4px;padding-bottom:4px;">
		  		<el-button type="primary" @click="resetSelection" :disabled="this.selectRole.BAFMSID == null">{{rolesList.rolesList_19}}</el-button>
		  		<el-button type="primary" @click="submitAuthForm" :disabled="this.selectRole.BAFMSID == null" :loading="authLoading">{{rolesList.rolesList_16}}</el-button>
		  	</div>
		  </div>
		</div>
	</div>
</template>

<script>
	import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'rolesList',
		inject:['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					addPerms: 'roles:rolesList:add', //新增权限标识
					searchPerms: 'roles:rolesList:search', //搜索权限标识
					editPerms: 'roles:rolesList:edit', //编辑权限标识
					deletePerms: 'roles:rolesList:delete', //删除权限标识

					disabled: false
				},

				web_suuid: sessionStorage.getItem('ms_web_suuid'), //web侧 登录ID
				

				// 开始时间
				starttime: {
					disabledDate: time => {
					  if (this.query.end) {
						return (
						  time.getTime() > new Date(this.query.end).getTime()
						)
					  } else {
						// 不能大于当前日期
						return time.getTime() > Date.now()
					  }
					}
				},
				// 结束时间
				endTime: {
					disabledDate: time => {
					  if (this.query.start) {
						return (
						  time.getTime() > Date.now() ||
						  time.getTime() < new Date(this.query.start).getTime() - 8.64e7 // 加- 8.64e7则表示包当天
						)
					  } else {
						return time.getTime() < Date.now()
					  }
					}
				},

				query: {
					bafname: '',
					start: '',
					end: '',
					pageIndex: 1, //当前页
					pageSize: 10 //这是当前每页显示的条数
				},
				tableData: [],
				pageTotal: 0, // 总条数
				loading:false,
				selections: []  ,// 列表选中列

				operation: false, // true:新增, false:编辑
				dialogVisible: false, // 新增编辑界面是否显示
				editLoading: false,
				dataFormRules: {
					BAFNAME: [
						// { required: true, message: this.rolesList.rolesList_20, trigger: 'blur' }
					]
				},
				// 新增编辑界面数据
				dataForm: {
					BAFMSID: 0,
					BAFNAME: '',
					BAFREMK: ''
				},
				selectRole: {},
				menuData: [],
				menuLoading: false,
				authLoading: false,
				checkAll: false,
				currentRoleMenus: [],
				defaultProps: {
					children: 'children',
					label: 'name'
				},
				idx: -1,
				id: -1,
				rolesList: {
					rolesList_0: "角色管理",
					rolesList_1: "请搜索角色名",
					rolesList_2: "开始日期",
					rolesList_3: "结束日期",
					rolesList_4: "搜索",
					rolesList_5: "新增",
					rolesList_6: "角色名",
					rolesList_7: "备注",
					rolesList_8: "创建人",
					rolesList_9: "创建时间",
					rolesList_10: "操作",
					rolesList_11: "编辑",
					rolesList_12: "删除",
					rolesList_13: "新增角色",
					rolesList_14: "编辑角色",
					rolesList_15: "返回",
					rolesList_16: "提交",
					rolesList_17: "拼命加载中",
					rolesList_18: "全选",
					rolesList_19: "重置",
					rolesList_20: "请输入角色名",
					rolesList_21: "请求失败",
					rolesList_22: "您确定要删除吗？",
					rolesList_23: "提示",
					rolesList_24: "删除失败",
					rolesList_25: "删除成功",
					rolesList_26: "确认提交吗？",
					rolesList_27: "角色名称不能重复新增",
					rolesList_28: "操作失败",
					rolesList_29: "操作成功",
					rolesList_30: "超级管理员拥有所有菜单权限，不允许修改！",
					rolesList_31: "目录",
					rolesList_32: "菜单",
					rolesList_33: "按钮",
					rolesList_34: "顶级菜单",
					rolesList_35: "角色菜单授权",
					rolesList_36: "角色名：",
					rolesList_37: "备注："
				},

			};
		},
		computed: {
		},
		created() {
			let curpagenum = this.query.pageIndex; //当前页码
			this.getData(curpagenum); //获取当前角色列表数据
			this.get_BAF_List_Count(); //获取当前列表条数

			this.findTreeData(); // 获取角色菜单授权数据
		},
		mounted() {
			 this.$bus.$on('change', ()=> {
				 //刷新当前页面
			     this.reload()
			  })
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//ID格式化
			idFormat:function(row,column){
				return Number(row.BAFMSID);
			},
			//时间格式化
			dateFormat:function(row,column){
			　  var t=new Date(row.BAFINDT);//row 表示一行数据, date 表示要格式化的字段名称
			　　var year=t.getFullYear(),
			　　 month=t.getMonth()+1,
			　　 day=t.getDate(),
			　　  hour=t.getHours(),
			　　  min=t.getMinutes(),
			　　  sec=t.getSeconds();
			　　 var newTime=year+'-'+
			　　  (month<10?'0'+month:month)+'-'+
			　　   (day<10?'0'+day:day)+' '+
			　　  (hour<10?'0'+hour:hour)+':'+
			　　  (min<10?'0'+min:min)+':'+
			　　  (sec<10?'0'+sec:sec);
			　　return newTime;
			},
			// 获取导航菜单树
			findTreeData: function () {
				this.menuLoading = true

				const self = this;
				var postUrl = 'WCF/WEB/svcBAG.svc/GET_BAG_TreeList';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sUAAID: self.web_suuid //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resDateArr = response.data;

					this.menuData =resDateArr;
					this.menuLoading = false
				})
				.catch((error) => {
					this.loading = false;//取消loading效果
					this.$message({
						message: this.rolesList.rolesList_21, //请求失败
						type: 'error'
					});
				});

			},
			// 选择切换
			selectionChange: function (selections) {
			  this.selections = selections
			  this.$emit('selectionChange', {selections:selections})
			},
			// 获取角色数据
			getData(curpage) {
				this.loading = true;//初始化加载loading效果
				const self = this;
				var postUrl = 'WCF/WEB/svcBAF.svc/GET_BAF_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sUAAID: self.web_suuid, //web侧 登录ID  tihs.web_suuid
							sBAFNAME: self.query.bafname.trim(), //角色名
							sSTARTDATE: self.query.start, //开始日期
							sENDDATE: self.query.end, //结束日期
							sPageIndex: curpage, //页码
							sPageSize: self.query.pageSize //每页显示条数
						}
					)
					.then((response) => {
						this.loading = false;//取消loading效果

						// //请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;

						if (resCount > 0) {
							//渲染数据 List
							this.tableData = response.data.KKDT; //数据数组
						}
						else{
							this.tableData = []; //数据数组
						}

						//this.pageTotal = Number(resCount); //总条数
					})
					.catch((error) => {
						this.loading = false;//取消loading效果
						this.$message({
							message: this.rolesList.rolesList_21, //请求失败
							type: 'error'
						});
					});
			},
			// 获取当前列表条数
			get_BAF_List_Count(){

				const self_count = this;

				var postUrl = 'WCF/WEB/svcBAF.svc/Get_BAF_List_Count';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sUAAID: self_count.web_suuid, //web侧 登录ID  tihs.web_suuid
						sBAFNAME: self_count.query.bafname.trim(), //角色名
						sSTARTDATE: self_count.query.start, //开始日期
						sENDDATE: self_count.query.end //结束日期
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					this.pageTotal = Number(resCount); //总条数
				})
				.catch((error) => {
					this.$message({
						message: this.rolesList.rolesList_21, //请求失败
						type: 'error'
					});
				});
			},
			// 触发搜索按钮
			handleSearch() {
				this.$set(this.query, 'pageIndex', 1);
				this.getData(1);
				this.get_BAF_List_Count(); //获取当前列表条数
			},
			// 删除单个操作
			handleDelete(index, row) {
				//二次确认删除
				this.$confirm(this.rolesList.rolesList_22, this.rolesList.rolesList_23, {
						type: 'warning'
					})
					.then(() => {

						 //删除接口
						 const self = this;
						 var postUrl='WCF/WEB/svcBAF.svc/DEL_BAF_BYID';
						 //网络请求接口
						 this.$axios.post(
						 	//请求的url
						 		postUrl,
						 	//请求参数
						 	{
						 		sUAAID: self.web_suuid,   		//web侧 登录ID  tihs.web_suuid
						 		sBAFID: row.BAFMSID   			//BAFMSID
						 	}
						 )
						 .then((response) =>{
							//请求成功返回的数据
							let resStatus = response.status; //200 代表请求成功
							let resKKSTR = response.data.KKSTR;

							if(resStatus == "200"){
								if(resKKSTR == "N"){
									this.$message({
									  message: this.rolesList.rolesList_24,  //删除失败
									  type: 'error'
									});
								}
								else if(resKKSTR == "Y"){
									this.$message.success(this.rolesList.rolesList_25); //删除成功
									this.tableData.splice(index, 1);

									//刷新当前页面
									this.reload()
								}
							}
							else{
								this.$message({
								  message: this.rolesList.rolesList_21,  //请求失败
								  type: 'error'
								});
							}
						})
						 .catch((error) =>{
						 	this.$message({
						 	  message: this.rolesList.rolesList_21,  //请求失败
						 	  type: 'error'
						 	});
						});
					})
					.catch((error) =>{
					 	console.log("cancel"); //取消
					});
			},
			getRowKeys (row) {
			 return row.BAFMSID; // id为列表数据的唯一标识
			},
			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				this.$set(this.query, 'pageIndex', currentPage);
				// 调取列表的函数，初始化时调一次
				this.getData(currentPage);
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(size);
			},
			// 显示新增界面
			handleAdd: function () {
				this.dialogVisible = true
				this.operation = true
				this.dataForm = {
					BAFMSID: 0,
					BAFNAME: '',
					BAFREMK: ''
				}
			},
			// 显示编辑界面
			handleEdit: function (row) {
				this.dialogVisible = true
				this.operation = false
				Object.assign(this.dataForm, row);
			},
			// 表单提交
			submitForm: function () {
				this.$refs.dataForm.validate((valid) => {
					if (valid) {
						this.$confirm(this.rolesList.rolesList_26, this.rolesList.rolesList_23, {}).then(() => {
							this.editLoading = true

							const self = this;
							var postUrl='WCF/WEB/svcBAF.svc/SAVE_BAF';
							let params = Object.assign({}, self.dataForm);

							//网络请求接口
							this.$axios.post(
								//请求的url
								 postUrl,
								//请求参数
								{
									sUAAID: self.web_suuid,   	//web侧 登录ID  tihs.web_suuid
									sBAFMSID: params.BAFMSID,   //角色ID
									sBAFNAME: params.BAFNAME,   //角色名称
									sBAFREMK: params.BAFREMK,   //角色备注
									sOPERATION: this.operation //新增操作：true，编辑操作：false
								}
							)
							.then((response) =>{
								this.editLoading = false;
								//请求成功返回的数据
							    let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if(resStatus == "200"){
									if(resKKSTR == "E"){
										this.$message({
										  message: this.rolesList.rolesList_27,  //菜单名称不能重复新增
										  type: 'error'
										});
									}
									else if(resKKSTR == "N"){
										this.$message({
										  message: this.rolesList.rolesList_28,  //新增角色失败
										  type: 'error'
										});
									}
									else if(resKKSTR == "Y"){
										this.$message.success(this.rolesList.rolesList_29);  // 操作成功
										this.dialogVisible = false
										this.$refs['dataForm'].resetFields()

									}
								}
								else{
									this.$message({
									  message: this.rolesList.rolesList_21,  //请求失败
									  type: 'error'
									});
								}
								this.reload();
								this.getData(1);
							})
							.catch((error) =>{
								this.$message({
								  message: this.rolesList.rolesList_21,  //请求失败
								  type: 'error'
								});
							});
						})
					}
				})
			},
			// 角色菜单授权提交
			submitAuthForm() {
				let roleId = this.selectRole.BAFMSID
				this.authLoading = true
				let checkedNodes = this.$refs.menuTree.getCheckedNodes(false, true)

				let roleMenus = []
				for(let i=0, len=checkedNodes.length; i<len; i++) {
					let roleMenu = { roleId:roleId, menuId:checkedNodes[i].id }
					roleMenus.push(roleMenu)
				}

				//设置权限
				const self = this;
				var postUrl='WCF/WEB/svcBAF.svc/SAVE_RoleMenus';

				//网络请求接口
				this.$axios.post(
					//请求的url
					 postUrl,
					//请求参数
					{
						sUAAID: self.web_suuid,   	//web侧 登录ID  tihs.web_suuid
						sRoleMenus: JSON.stringify(roleMenus)  //角色控制的菜单
					}
				)
				.then((response) =>{
					//请求成功返回的数据
					let resStatus = response.status; //200 代表请求成功
					let resKKSTR = response.data.KKSTR;

					if(resStatus == "200"){
						if(resKKSTR == "Y"){
							this.$message.success(this.rolesList.rolesList_29);  // 操作成功
							this.$parent.getSideBar();
						}
						else{
							this.$message({
							  message: this.rolesList.rolesList_28,  //操作失败
							  type: 'error'
							});
						}
					}
					else{
						this.$message({
						  message: this.rolesList.rolesList_21,  //请求失败
						  type: 'error'
						});
					}

					this.authLoading = false
				})
				.catch((error) =>{
					this.$message({
					  message: this.rolesList.rolesList_21,  //请求失败
					  type: 'error'
					});
				});

			},
			//渲染内容
			renderContent(h, { node, data, store })
			{
				return (
				<div class="column-container">
					<span style="text-algin:center;margin-right:80px;">{data.name}</span>
					<span style="text-algin:center;margin-right:80px;">
						<el-tag type={data.type === 0?'':data.type === 1?'success':'info'} size="small">
							{data.type === 0?this.rolesList.rolesList_31:data.type === 1?this.rolesList.rolesList_32:this.rolesList.rolesList_33}
						</el-tag>
					</span>
					<span style="text-algin:center;margin-right:80px;"> <i class={data.icon}></i></span>
					<span style="text-algin:center;margin-right:80px;">{data.parentName?data.parentName:this.rolesList.rolesList_34}</span>
					<span style="text-algin:center;margin-right:80px;">{data.url?data.url:'\t'}</span>
				</div>);
			},
			// 树节点选择监听
			handleMenuCheckChange(data, check, subCheck) {
				if(check) {
					// 节点选中时同步选中父节点
					let parentId = data.parentId
					this.$refs.menuTree.setChecked(parentId, true, false)
				} else {
					// 节点取消选中时同步取消选中子节点
					if(data.children != null) {
						data.children.forEach(element => {
							this.$refs.menuTree.setChecked(element.id, false, false)
						});
					}
				}
			},
			// 角色选择改变监听
			handleRoleSelectChange(val) {
				if(val == null) {
					return
				}
				this.selectRole = val

				const self = this;
				var postUrl = 'WCF/WEB/svcBAG.svc/FIND_RoleMenus'; //查询角色菜单集合
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sUAAID: self.web_suuid, 	//web侧 登录ID  tihs.web_suuid
						sROLEID: val.BAFMSID 		//角色ID
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0)
					{
						this.currentRoleMenus = [];
						let optionsRoleMenu = response.data.KKDT;

						optionsRoleMenu.forEach(item => {
							const addnew = {
								id: parseInt(item.BAHBAGI),
								roleId: parseInt(item.BAHBAFI),
								menuId: parseInt(item.BAHBAGI)
							}

							this.currentRoleMenus.push(addnew);
							this.$refs.menuTree.setCheckedNodes(this.currentRoleMenus)
						})
					}
					else{
						this.currentRoleMenus = []; //数据数组
						this.$refs.menuTree.setCheckedNodes(this.currentRoleMenus)
					}
				})
				.catch((error) => {

					this.$message({
						message: this.rolesList.rolesList_21, //请求失败
						type: 'error'
					});
				});
			},
			// 重置选择
			resetSelection() {
				this.checkAll = false
				this.$refs.menuTree.setCheckedNodes(this.currentRoleMenus)
			},
			// 全选操作
			handleCheckAll() {
				if(this.checkAll) {
					let allMenus = []
					this.checkAllMenu(this.menuData, allMenus)
					this.$refs.menuTree.setCheckedNodes(allMenus)
				} else {
					this.$refs.menuTree.setCheckedNodes([])
				}
			},
			// 递归全选
			checkAllMenu(menuData, allMenus) {
				menuData.forEach(menu => {
					allMenus.push(menu)
					if(menu.children) {
						this.checkAllMenu(menu.children, allMenus)
					}
				});
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 20%;
	}

	.menu-container {
		margin-top: 10px;
		margin-bottom: 30px;
	}
	.menu-header {
		padding-left: 8px;
		padding-bottom: 5px;
		text-align: left;
		font-size: 16px;
		color: rgb(24, 144, 255);

	}
	.el-dialog__footer {
		text-align: center;
		height: 80px;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}
	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		/* padding-left: 28px; */
	}
</style>
